<div class="modal-header-contratante">
  <button class="btn-close-modal" (click)="continuar(false)">✕</button>
  <span>Información Empresa</span>
</div>

<div class="col-md-12">
  <!-- Header búsqueda -->
  <div *ngIf="opciones == true" class="modal-dialog-header-b">
    <div class="container">
      <div class="row p-0 m-0 mt-2">
        <div class="col-md-12" style="padding-top: 10px">
          <mat-label style="color: #0372b9">Tipo de documento *</mat-label>
          <mat-form-field appearance="outline">
            <mat-select [(ngModel)]="selectedTipoDocumento" [disabled]="!permitirNuevaConsulta">
              <mat-option *ngFor="let doc of typeDocument" [value]="doc.codigo">
                {{ doc.codigo }} - {{ doc.tipo_documento.toUpperCase() }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      
      <div class="row p-0 m-0 mt-2">
        <div class="col-md-12">
          <mat-label style="color: #0372b9">Numero de documento *</mat-label>
          <mat-form-field appearance="outline">
            <input
              (keyup.enter)="permitirNuevaConsulta && searchEmpresa()"
              (input)="onDocumentoInput()"
              [(ngModel)]="documento"
              [disabled]="!permitirNuevaConsulta"
              matInput
              #message
              minlength="7"
              maxlength="30"
            />
            <mat-icon *ngIf="permitirNuevaConsulta" (click)="searchEmpresa()" matSuffix>search</mat-icon>
            <mat-hint align="end">{{ message.value.length }} / 30</mat-hint>
          </mat-form-field>
          <div class="documento-error" *ngIf="form.documento.messages">{{ form.documento.messages }}</div>
        </div>
      </div>
    </div>
  </div>

  <!-- Body información empresa -->
  <div class="modal-dialog-body-b">
    <div class="container body-content-centered">
      <br />
      <div *ngIf="datosEmpresa" class="info-grid">
        <p style="text-align: center; color: #000000; font-weight: 600 !important;">
          La siguiente empresa presenta negociaciones o contratos vigentes.
        </p>
        <div class="campo">
          <strong>Nombre / Empresa</strong>
          <div>{{ datosEmpresa.nombre }}</div>
        </div>
        <div class="campo">
          <strong>Estado de mora</strong>
          <div [ngClass]="{'mora-roja': datosEmpresa.estado_mora === 'EN MORA'}">
            {{ datosEmpresa.estado_mora === 'EN MORA' ? 'SI' : 'NO' }}
          </div>
        </div>
        <div class="campo asesor-col">
          <strong>Asesor población</strong>
          <div>
            {{ datosEmpresa.nombre_asesor || 'Sin asesor asignado' }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-dialog-footer-b">
    <div
      *ngIf="datosEmpresa && opciones == true"
      class="modal-dialog-button"
      style="background-color: #0372b9; color: #fff"
      (click)="continuar(true)"
    >
      Aceptar
    </div>
    <div class="modal-dialog-button" style="background-color: #0372b9; color: #fff" (click)="continuar(false)">
      Cerrar
    </div>
  </div>
</div>